<template>
  <div>
    <div class="black-overlay"></div>
    <div class="modal modal--welcomeback modal--unsubscribe" id="unsubscribe_modal">
      <div class="modal__content">
        <button class="btn modal-close"><i class="icon-close"></i></button>
        <div class="modal__header modal_ti_header">
        </div>
        <div class="modal__body">
          <h1>{{ userDetails.username }}, {{ getTranslations.home_modals_unsubscribe_do_you_want }}</h1>
          <img :src="getTranslations.project_config_modal_img" alt="">
          <p>{{ getTranslations.home_modals_unsubscribe_if_you_unsubscribe }}</p>
          <p>{{ getTranslations.home_modals_unsubscribe_do_you_want_continue }}</p>
          <p>{{ getTranslations.home_modals_unsubscribe_in_order_to_unsubscribe_send }}
          <span class="make_it_bold">{{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_unsub_unsubscribesms_modal_stop') }}
        </span> {{ getTranslations.home_modals_unsubscribe_to }}
          <span class="make_it_bold">{{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_unsub_unsubscribesms_modal_xxxx') }}</span> </p>
        </div>
        <div class="modal__footer">
        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'unsubscribe-sms',
  components: {
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'multiOperatorInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
    ]),
  },
};
</script>




// WEBPACK FOOTER //
// src/components/home/modals/UnsubscribeSms.vue